import { Country } from '../enums'
import type { BaseAddressDto, PersonAdditionalData, PersonDto } from './Person'
import type {
    InsuranceParamsDto,
    PolicyHolderDto,
    VehicleDto,
    VehicleIdentificationDto,
    VehiclePriceDto
} from './Step1'
import {
    InitialBaseAddressValues,
    InitialBaseParamsAddonValues,
    InitialBaseParamsValues,
    InitialGeneralParamsValues,
    InitialPersonValues,
    InitialPolicyHolderValues,
    InitialVehicleValues
} from './Step1'

export const DummyVehicle: VehicleIdentificationDto & VehicleDto & VehiclePriceDto = {
    ...InitialVehicleValues,
    druh: 17,
    palivo: 27,
    znacka: 'MERCEDES',
    zakladniModel: 'C',
    model: 'C 220 (C DIESEL W 205)',
    objem: 2143,
    vykon1: 125,
    celkovaHmotnost: 2115,
    pocetMistSezeni: 5,
    firstRegistrationDate: new Date(2014, 4, 15),
    mileage: 130000,
    usage: 20,
    price: 467400,
    priceType: 70,
    priceIncludeVat: true,
    licensePlate: '5AC2993',
    vin: 'WDD2050041F030914',
    equipment: [759, 748],
    security: [58, 60, 59]
}


export const DummyVehicleAddon = {
    druh: 17,
    palivo: 27,
    znacka: 'MERCEDES',
    zakladniModel: 'C',
    model: 'C 220 (C DIESEL W 205)',
    objem: 2143,
    vykon1: 125,
    celkovaHmotnost: 2115,
    pocetMistSezeni: 5,
    firstRegistrationDate: new Date(2014, 4, 15),
    mileage: 130000,
    price: 467400,
    priceType: 70,
    priceIncludeVat: true,
    licensePlate: '5AC2993',
    vin: 'WDD2050041F030914',
} as VehicleIdentificationDto & VehicleDto & VehiclePriceDto

export const DummyBaseAddress: BaseAddressDto = {
    ...InitialBaseAddressValues,
    postCode: '14000',
    country: `${Country.CZ}`,
    city: 'Praha - Michle'
}

export const DummyPerson: PersonDto = {
    ...InitialPersonValues,
    address: DummyBaseAddress,
    birthNumber: '8111111118',
    name: 'Jan ',
    surname: 'Novák',
    nationalityId: undefined
}

export const DummyPolicyHolder: PolicyHolderDto = {
    ...InitialPolicyHolderValues,
    person: DummyPerson as PersonAdditionalData
}

export const DummyStep1: InsuranceParamsDto = {
    nextPage: 'current',
    baseParams: InitialBaseParamsValues,
    vehicle: DummyVehicle,
    policyHolder: DummyPolicyHolder,
    generalParams: InitialGeneralParamsValues,
}

export const DummyStep1Addon: InsuranceParamsDto = {
    nextPage: 'current',
    baseParams: { ...InitialBaseParamsAddonValues, addonInsurers: [13, 18] },
    vehicle: DummyVehicleAddon,
    policyHolder: DummyPolicyHolder,
    generalParams: {
        ...InitialGeneralParamsValues,
        paymentFrequency: undefined,
        contractAcceptationType: undefined
    },
}